import type { LetterProviderValue } from '@/Ship/Contracts/LetterProvider'

/**
 * Довідник «Шаблони листів» (`SPEC-013` §4.1, §9.1): адреси API, підписи полів
 * і межі файлів.
 */

export const LETTER_TEMPLATE_REST_URL = '/services/letter_templates'

/** Крок 1 двокрокового завантаження вкладення (G-05). */
export const LETTER_TEMPLATE_FILE_UPLOAD_URL = '/services/letter_template_files'

/** Каталог змінних провайдера (§5.7). */
export const LETTER_TEMPLATE_VARIABLES_URL = '/services/letter_templates/variables'

/**
 * Типи вкладень — білий список легасі (Q13.8 (а)), той самий, що в договорів
 * CRM: бек приймає їх за розширенням і вмістом (`CrmFileMimePolicy::Contract`).
 */
export const LETTER_TEMPLATE_FILE_EXTENSIONS = [
    'docx',
    'dotx',
    'xlsx',
    'xltx',
    'pptx',
    'ppsx',
    'potx',
    'sldx',
    'oxt',
    'pdf',
    'gif',
    'jpg',
    'jpeg',
    'jp2',
    'png',
    'webp',
    'heic',
]

/** Стеля — ядровий nginx (`SPEC-008` §5.7.3). */
export const LETTER_TEMPLATE_FILE_MAX_SIZE_MB = 10

/** Підписи — дослівно з легасі (`SPEC-013` §9.7), «Клієнти / перевізники» — Q13.11 (а). */
export const LETTER_TEMPLATE_LABELS = {
    provider: 'Провайдер',
    clients: 'Клієнт',
    carriers: 'Перевізник',
    bindings: 'Клієнти / перевізники',
    isDefault: 'За замовчуванням',
    // Етап 2 (`SPEC-025` §3.2, ДС-01): замість `sorting = 10000` легасі — затверджує замовник
    isOfficialApplication: 'Офіційний лист заявки',
    title: 'Назва',
    subject: 'Тема',
    toWhom: 'E-mail адреси для відправки',
    cc: 'E-mail адреси для відправки копій листів',
    bcc: 'E-mail адреси для відправки прихованих копій листів',
    body: 'Шаблон',
    attachments: 'Вкладення',
    sorting: 'Сортування',
} as const

/** Змінна каталогу так, як її віддає `GET …/variables` (§5.7). */
export interface LetterTemplateVariable {
    /** `${ключ}` */
    key: string
    label: string
}

/** Пов'язаний запис так, як його віддає бек (`client:short:read`, `carrier:short:read`). */
export interface LetterTemplateBinding {
    '@id'?: string
    uuid?: string
    title?: string | null
}

/** Значення форми шаблону, які читають шаблон і обробники. */
export interface LetterTemplateFormValues {
    uuid?: string
    provider?: LetterProviderValue | null
    clients?: LetterTemplateBinding[] | null
    carriers?: LetterTemplateBinding[] | null
    [key: string]: unknown
}
